export const WALLET_CONNECT_ABORTED = "wallet:connect-aborted";
